export function SpectraLoading({label='Carregando…'}:{label?:string}) {
  return <div className="spectra-loading" role="status" aria-live="polite"><div className="spectra-loading-logo"><img src="/logo.png" alt=""/></div><strong>{label}</strong></div>
}
